module.exports = "/assets/CCLogo-5cba84d1ee7ecc25d19e18e299b560cd.png";